import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_AetnaBetterHealthOfLouisiana = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_AetnaBetterHealthOfLouisiana' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><h2>AETNA BETTER HEALTH® OF LOUISIANA</h2></p>
                <p className='w-750'><h3>Prior authorization form</h3></p>

                <p className='w-750'>
                    <b>Phone:</b> 1-855-242-0802<br />
                    <b>Physical Health Fax:</b> 1-844-227-9205<br />
                    <b>Behavioral Health Fax:</b> 1-844-634-1109 <br />
                </p>

                <p className='w-750'><b>For urgent requests (required within 24 hours), call Aetna Better Health of Louisiana at 1-855-242-0802</b></p>
                <p className='w-750'><span className='eleHeader'>REQUESTING PHYSICIAN OR PROVIDER INFORMATION …</span></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <b>Referring Provider / Requesting Provider</b>
                        </td>
                        <td className='w-375'>
                            <b>Place of Service or Facility Name</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Name:</td>
                        <td className='w-225'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' />
                        </td>
                        <td className='w-150'>Name:</td>
                        <td className='w-225'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Address:</td>
                        <td className='w-225'>
                            <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' />
                        </td>
                        <td className='w-150'>Address:</td>
                        <td className='w-225'>
                            <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Telephone #:</td>
                        <td className='w-225'>
                            <input type='text' id='txtTelephone_1' name='txtTelephone_1' className='add-only' />
                        </td>
                        <td className='w-150'>Telephone #:</td>
                        <td className='w-225'>
                            <input type='text' id='txtTelephone_2' name='txtTelephone_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Fax #:</td>
                        <td className='w-225'>
                            <input type='text' id='txtFax_1' name='txtFax_1' className='add-only' />
                        </td>
                        <td className='w-150'>Fax #:</td>
                        <td className='w-225'>
                            <input type='text' id='txtFax_2' name='txtFax_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Specialty:</td>
                        <td className='w-225'>
                            <input type='text' id='txtSpecialty_1' name='txtSpecialty_1' className='add-only' />
                        </td>
                        <td className='w-150'>Specialty:</td>
                        <td className='w-225'>
                            <input type='text' id='txtSpecialty_2' name='txtSpecialty_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>National Provider Identification (NPI):</td>
                        <td className='w-225'>
                            <input type='text' id='txtNationalProviderIdentification_1' name='txtNationalProviderIdentification_1' className='add-only' />
                        </td>
                        <td className='w-150'>National Provider Identification (NPI):</td>
                        <td className='w-225'>
                            <input type='text' id='txtNationalProviderIdentification_2' name='txtNationalProviderIdentification_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Contact Person:</td>
                        <td className='w-225'>
                            <input type='text' id='txtContactPerson_1' name='txtContactPerson_1' className='add-only' />
                        </td>
                        <td className='w-150'>Contact Person:</td>
                        <td className='w-225'>
                            <input type='text' id='txtContactPerson_2' name='txtContactPerson_2' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>REFERRAL / AUTHORIZATION INFORMATION…</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>{`Problem / Diagnosis (ICD-10 Code(s)):`}</span>
                    <textarea id='txtProblemDiagnosis' name='txtProblemDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Procedure / Test Requested (CPT Code(s)):`}</span>
                    <textarea id='txtProcedure' name='txtProcedure' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Appointment or Service: </span>
                            <input type='date' id='txtDateOfAppointment' name='txtDateOfAppointment' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of Visits Required: </span>
                            <input type='text' id='txtVisitsRequired' name='txtVisitsRequired' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Procedure (circle one): </span>
                            <input type='radio' id='rbInpatient' name='rbTypeOfProcedure' className='add-only' value='Inpatient' /> Inpatient &nbsp;
                            <input type='radio' id='rbOutpatient' name='rbTypeOfProcedure' className='add-only' value='Outpatient' /> Outpatient &nbsp;
                            <input type='radio' id='rbInOffice' name='rbTypeOfProcedure' className='add-only' value='InOffice' /> In Office
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other Clinical Information -</span>
                    <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, hospitalizations):</span>
                    <textarea id='txtClinicalInformation' name='txtClinicalInformation' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











